import { useState } from "react";
const Experience = ({ experienceYearsList, setExperienceYearsList }) => {
  const [experienceYears, setExperienceYears] = useState("");
  const [experienceDescription, setExperienceDescription] = useState("");

  const handleAddExperience = () => {
    if (!experienceYears.trim() || !experienceDescription.trim()) return;

    setExperienceYearsList([
      ...experienceYearsList,
      { experienceYears, experienceDescription },
    ]);

    setExperienceYears("");
    setExperienceDescription("");
  };

  const handleDeleteExperience = (index) => {
    setExperienceYearsList(
      experienceYearsList.filter((_, i) => i !== index)
    );
  };

  return (
  <div className="flex flex-col mx-auto p-6 max-w-[900px] gap-6">
  {/* Years of Experience */}
  <div>
    <div className="flex items-center gap-2 mb-3">
      <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
      <label className="text-sm font-semibold text-gray-700">Years of Experience</label>
    </div>
    <input
      type="text"
      value={experienceYears}
      onChange={(e) => setExperienceYears(e.target.value)}
      placeholder="e.g., 3 years"
      className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
    />
  </div>

  {/* Description */}
  <div>
    <div className="flex items-center gap-2 mb-3">
      <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
      <label className="text-sm font-semibold text-gray-700">Experience Description</label>
    </div>
    <textarea
      value={experienceDescription}
      onChange={(e) => setExperienceDescription(e.target.value)}
      placeholder="Describe your teaching experience..."
      className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all min-h-[120px] resize-none"
    />
  </div>

  {/* Add Button */}
  <div>
    <button
      className="px-6 py-3 bg-[#0f6abf] text-white text-sm font-medium rounded-xl hover:bg-[#0a5ca8] transition-colors"
      onClick={handleAddExperience}
    >
      Add Experience
    </button>
  </div>

  {/* Experience List */}
  {experienceYearsList.length > 0 && (
    <div className="space-y-3 mt-2">
      {experienceYearsList.map((item, index) => (
        <div
          key={index}
          className="flex justify-between items-start bg-white p-4 border border-gray-200 rounded-xl hover:border-gray-300 transition-colors"
        >
          <div className="space-y-1">
            <span className="text-sm font-semibold text-gray-900">{item.experienceYears}</span>
            <p className="text-sm text-gray-600">{item.experienceDescription}</p>
          </div>

          <button
            className="p-2 text-red-500 hover:bg-red-50 rounded-lg transition-colors"
            onClick={() => handleDeleteExperience(index)}
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
            </svg>
          </button>
        </div>
      ))}
    </div>
  )}
</div>

  );
};

export default Experience;
